import { accessGroupContent } from "./access_groups/accessGroupContent";
import { accessGroupMembers } from "./access_groups/accessGroupMembers";
import { accessGroups } from "./access_groups/accessGroups";
import { accessGroupSources } from "./access_groups/accessGroupSources";
import { communityMemberPaymentMethods } from "./communityMemberPaymentMethods";
import { communityReviews } from "./communityReviews";
import { connections } from "./connect/connections";
import { connectSettings } from "./connect/settings";
import { onboardings } from "./onboardings";
import { paywalls } from "./paywalls";
import { search } from "./search";

export const admin = {
  search,
  paywalls,
  communityMemberPaymentMethods,
  communityReviews,
  accessGroups,
  accessGroupMembers,
  accessGroupContent,
  accessGroupSources,
  connectSettings,
  connections,
  onboardings,
};
